export default "__VITE_ASSET__daa2999b__"